export default __webpack_public_path__ + "static/media/acxiom.26711be2.svg";